import type { ReactNode } from 'react';
import { Campo } from './ui';

/**
 * Par de campos "Senha" + "Confirmar senha" — compartilhado por primeiro
 * acesso e redefinição de senha (mesmo par, mesma validação em
 * `lib/validacaoSenha`). O erro (curta demais ou não coincide) aparece só no
 * campo "Senha", igual ao comportamento original do primeiro acesso.
 */
export function CamposSenha({
  senha,
  setSenha,
  confirma,
  setConfirma,
  erro,
}: {
  senha: string;
  setSenha: (v: string) => void;
  confirma: string;
  setConfirma: (v: string) => void;
  erro?: string;
}): ReactNode {
  return (
    <>
      <Campo
        rotulo="Senha"
        type="password"
        autoComplete="new-password"
        autoFocus
        ajuda="Mínimo de 8 caracteres."
        erro={erro}
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
      />
      <Campo
        rotulo="Confirmar senha"
        type="password"
        autoComplete="new-password"
        value={confirma}
        onChange={(e) => setConfirma(e.target.value)}
      />
    </>
  );
}
